module.exports = __webpack_public_path__ + "img/B20-20190415_03.3668498f.jpg";